import React from 'react';
import { WebPlayerContextType } from './types';

export const WebPlayerContext = React.createContext<WebPlayerContextType>({} as WebPlayerContextType);
